var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-file-input.ts
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { event } from "@adornis/chemistry/decorators/event.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { injectAttributesOf } from "@adornis/chemistry/directives/inject-attributes.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-icon.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { FormField } from "@adornis/formfield/form-field.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { createRef, ref } from "lit/directives/ref.js";
import { of, switchMap } from "rxjs";
import { AdornisFile } from "../db/files.js";
var XFileInput = class extends FormField {
  constructor() {
    super(...arguments);
    this.placeholder = "";
    this.fileEntity = AdornisFile;
    this.currentFiles = new RXController(
      this,
      this.value.observable.pipe(
        switchMap(
          (id) => Array.isArray(id) && !id.length || !id ? of(null) : this.fileEntity.getByID(Array.isArray(id) ? id : [id])(this.fileEntity.allFields)
        )
      )
    );
    this._inputReference = createRef();
  }
  render() {
    const currentFilesString = this.currentFiles.value?.map((f) => f.meta?.fileName || f._id).join(", ");
    const showLabel = this.placeholder && (this.selectedFile || currentFilesString) || this.error;
    const selectedFileLabel = (this.selectedFiles?.length || 0) > 1 ? `${this.selectedFiles.length} Dateien ausgew\xE4hlt (${this.selectedFiles.map((file) => file.name).join(", ")})` : this.selectedFile?.name;
    return xComponents(html`
      <x-formfield-wrapper
        ${injectAttributesOf(this, ["tabindex"])}
        ?show-label=${showLabel}
        one-line
        @cleared=${() => {
      this.value.next(null);
      this.selectedFile = void 0;
      this.selectedFiles = void 0;
      this.preview = false;
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: null } }));
    }}
        @click=${() => !this.disabled && this._inputReference.value?.click()}
      >
        <x-flex ${css({ position: "relative" })} horizontal crossaxis-center space="md">
          <x-icon ${css({ color: this.colors.neutral.shade(800) })}> attach_file </x-icon>
          ${this.currentFiles.isLoading ? html` <x-text> Loading... </x-text> ` : nothing}
          <x-text
            flex
            ellipsis
            .value="${selectedFileLabel || currentFilesString || this.placeholder}"
            tone=${!selectedFileLabel ? "placeholder" : ""}
          >
          </x-text>
          <input
            type="file"
            ${css({ position: "absolute", top: "0", left: "0", height: "100%", width: "100%", opacity: "0" })}
            @change=${(e) => {
      const files = Array.from(e.currentTarget.files);
      this.selectedFile = files[0];
      this.selectedFiles = files;
      this.preview = true;
    }}
            @click=${(e) => e.stopPropagation()}
            ${injectAttributesOf(this, ["type"])}
            ${ref(this._inputReference)}
          />
        </x-flex>
      </x-formfield-wrapper>
    `);
  }
  async preValidate() {
    const commitValue = (value) => {
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value } }));
      this.value.next(value);
    };
    const isSingleFile = !this.hasAttribute("multiple");
    if (isSingleFile) {
      if (!this.selectedFile)
        return commitValue(this.value.value);
      const fileID = await this.fileEntity.upload(this.selectedFile, { additionalInfo: this.additionalInfo });
      if (fileID)
        return commitValue(fileID);
      else
        throw new Error("issue while uploading");
    } else {
      if (!this.selectedFiles || !this.selectedFiles.length)
        return commitValue(this.value.value);
      const fileIDs = await Promise.all(
        this.selectedFiles.map((file) => this.fileEntity.upload(file, { additionalInfo: this.additionalInfo }))
      );
      if (fileIDs.length && fileIDs.every((x) => !!x))
        return commitValue(fileIDs);
      else
        throw new Error("issue while uploading files");
    }
  }
};
__decorateClass([
  property()
], XFileInput.prototype, "placeholder", 2);
__decorateClass([
  property({ attribute: false })
], XFileInput.prototype, "fileEntity", 2);
__decorateClass([
  property({ attribute: false })
], XFileInput.prototype, "additionalInfo", 2);
__decorateClass([
  state(),
  event
], XFileInput.prototype, "selectedFile", 2);
__decorateClass([
  state(),
  event
], XFileInput.prototype, "selectedFiles", 2);
__decorateClass([
  state()
], XFileInput.prototype, "currentFiles", 2);
XFileInput = __decorateClass([
  customElement("x-file-input")
], XFileInput);
export {
  XFileInput
};
